import { render, staticRenderFns } from "./AdvancedPriceRule.vue?vue&type=template&id=35c65900"
import script from "./AdvancedPriceRule.vue?vue&type=script&lang=js"
export * from "./AdvancedPriceRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports